export default "__VITE_ASSET__CQeEHnZm__"